import React, { useEffect } from "react";
import { MasterConfigs } from "../../../../interfaces/entity";
import HeadingAndText from "../../../../components/HeadingAndText";
import RenderForm from "../../../../components/Forms/Form";
import { useDispatch } from "react-redux";
import { getData } from "../../../../actions/apiCall";
import { postData, putData } from "../../../../actions/developer";
import { notification } from "antd";

const AssetRequestSettings = () => {
    const [id, setId] = React.useState(null);
    const dispatch = useDispatch();

    const AssetCondition: MasterConfigs = {
        api: () => `/assets-request-settings`,
        title: 'Assets Request Settings',
        modalTitle: (action) => `${action} ${AssetCondition.title}`,
        getColumns: () => [],
        getFormColumns: () => [
            {
                label: 'Allow employee to raise new/replacement requests.',
                name: 'allowRequest',
                type: 'checkbox',
                span: 24,
                checkboxProps: {
                    onChange: addAssetRequestSettings
                }
            },
        ],
    }

    useEffect(() => {
        getAssetRequestSettings();
    }, []);

    const getAssetRequestSettings = async () => {
        try {
            const response = await dispatch(getData(`/assets-request-settings`));
            if (response && response.data && response.data.length) {
                setId(response.data[0]._id);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const addAssetRequestSettings = async (value) => {
        try {
            console.log(value.target.checked);
            if (id) {
                const response = await dispatch(putData(`/assets-request-settings/${id}`, { allowRequest: value.target.checked }));
                if (response) {
                    notification.success({ message: 'Asset Request Settings updated successfully' });
                }
            } else {
                const response = await dispatch(postData(`/assets-request-settings`, { allowRequest: value.target.checked }));
                if (response && response.data) {
                    setId(response.data._id);
                    notification.success({ message: 'Asset Request Settings added successfully' });
                }
            }
        } catch (error) {
            console.log(error);
        }
    }

    return <>
        <HeadingAndText heading="Asset Request Settings" text="Manage asset request settings." />
        <div className="bg-white p-4 mb-4 mt-2 w-1/4">
            <RenderForm id={id} config={AssetCondition} />
        </div>
    </>
}

export default AssetRequestSettings;